export const getIsOddIndex = itemIndex => itemIndex % 2 === 0
